import React from 'react';
import { MaintenanceBanner } from '@mobilitystore/components-interface';
import { MAINTENANCE_CONFIG } from '../../../actions/configuration';
import { getEnvironment } from '../../../utils';

const MaintenanceBannerWrapper = React.memo(() => {
  return (
    <MaintenanceBanner
      applicationId={MAINTENANCE_CONFIG.APPLICATION_ID}
      environment={getEnvironment(MAINTENANCE_CONFIG.ENVIRONMENT)}
      tenantId={MAINTENANCE_CONFIG.TENANT_ID}
      region={MAINTENANCE_CONFIG.REGION}
      refreshInterval={MAINTENANCE_CONFIG.REFRESH_INTERVAL}
      enableRealTimeUpdates={MAINTENANCE_CONFIG.ENABLE_REAL_TIME_UPDATES}
    />
  );
});

// Set display name for better debugging
MaintenanceBannerWrapper.displayName = 'MaintenanceBannerWrapper';

export default MaintenanceBannerWrapper;
